<script>
    export let rules;
    export let lastRules = '...';
    export let eventClass;
    export let isRoundOn = false;
    export let isGameOn = false;
    export let round;
    export let lang = 'pl';
    import { texts } from './texts.js';
</script>

<div class={eventClass}>
    <div class="main-title">
        <h2>{texts[lang].this_round_header}</h2>
    </div>
    <div class="rewerse">
        <div>
            <h2>{texts[lang].event_header} <i class="fas fa-exclamation" /></h2>
            <p>{@html rules || '...'}</p>
            <br />
        </div>
        {#if isGameOn && !isRoundOn && round > 1}
            <div class="smaller">
                <h4>
                    {texts[lang].previous_round}<i class="fas fa-exclamation" />
                </h4>
                <p>{@html lastRules || '...'}</p>
            </div>
        {/if}
    </div>
</div>
